define(
    'BTM.ItemSearcherCustomization.ItemSearcherCustomization'
    , [
        'SC.Configuration', 'underscore', 'Utils'
    ]
    , function (
        Configuration, _, Utils
    ) {
        'use strict';

        return {
            mountToApp: function mountToApp(container) {
                var enabled = Configuration.get('itemSearcherCustomization.enabled');
                if (!enabled) {
                    return;
                }
                try {
                    var SiteSearchView = require('SiteSearch.View');
                    var Session = require('Session');
                    if (SiteSearchView) {
                        _.extend(SiteSearchView.prototype, {
                            executeSearch: function (keywords) {
                                if (keywords) {
                                    this._executeSearch(keywords);

                                    /*const self = this;
                                    const plp_component = this.application && this.application.getComponent('PLP');

                                    if (!plp_component) {
                                        self._executeSearch(keywords);
                                    } else {
                                        plp_component.setSearchText({ searchText: keywords }).fail(function(result) {
                                            self._executeSearch(keywords);
                                        });
                                    }*/
                                }
                            },
                            _executeSearch: function (keywords) {
                                const search_url = '/' + Utils.getPathFromObject(Configuration, 'defaultSearchUrl');
                                const delimiters = Utils.getPathFromObject(Configuration, 'facetDelimiters');

                                //Bug 71331 - [Bronners] SuiteCommerce default sort for directory page vs search results
                                const defaultSort = Configuration.get("typeahead.sort", "relevance:desc");

                                const keywordsDelimited = delimiters
                                    ? delimiters.betweenFacetsAndOptions + 'keywords' + delimiters.betweenOptionNameAndValue
                                    : '?keywords=';

                                // If we are not in Shopping we have to redirect to it
                                if (Utils.getPathFromObject(Configuration, 'currentTouchpoint') !== 'home') {
                                    // we called this using fragment instead of # because bridged domain
                                    /*window.location.href = Utils.addParamsToUrl(Session.get('touchpoints.home'), {
                                        fragment: search_url + keywordsDelimited + keywords
                                    });*/
                                    window.location.href = search_url + keywordsDelimited + keywords + '&order=' + defaultSort;
                                }
                                // Else we stay in the same app
                                else {
                                    // We navigate to the default search url passing the keywords
                                    window.location.href = search_url + keywordsDelimited + keywords + this.getCurrentSearchOptions() + '&order=' + defaultSort;
                                    /*Backbone.history.navigate(
                                        search_url + keywordsDelimited + keywords + this.getCurrentSearchOptions(),
                                        { trigger: true }
                                    );*/
                                }
                            },
                        });
                    }
                } catch (e) {
                    console.log("Error ");
                }
            }
        };
    });
